__turbopack_context__.v({
  "clothingContent": "j4WhBa_clothingContent",
  "flexContent": "j4WhBa_flexContent",
  "flexContentGap12": "j4WhBa_flexContentGap12",
  "flexContentGap16": "j4WhBa_flexContentGap16",
  "flexContentGap8": "j4WhBa_flexContentGap8",
  "itemPrice": "j4WhBa_itemPrice",
  "menuTrigger": "j4WhBa_menuTrigger",
  "openSheetButton": "j4WhBa_openSheetButton",
  "optionalValue": "j4WhBa_optionalValue",
  "participantMenuSelectionListItem": "j4WhBa_participantMenuSelectionListItem",
  "participantRowListItem": "j4WhBa_participantRowListItem",
  "price": "j4WhBa_price",
  "priceBlock": "j4WhBa_priceBlock",
  "roomName": "j4WhBa_roomName",
  "sheetParticipantName": "j4WhBa_sheetParticipantName",
  "styledToggleGroup": "j4WhBa_styledToggleGroup",
});
